// Dev-only logger — keeps internal errors out of production console output.
export function logError(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
